import type { Question } from "@/schema/quizSchema";

type SliderQuestion = Extract<Question, { type: "slider" }>;

export function Slider({
  question,
  value,
  onAnswer,
}: {
  question: SliderQuestion;
  value: number | undefined;
  onAnswer: (value: number) => void;
}) {
  const current = value ?? Math.round((question.min + question.max) / 2);
  return (
    <div>
      <label className="qk-prompt">{question.prompt}</label>
      <input
        type="range"
        aria-label={question.prompt}
        min={question.min}
        max={question.max}
        step={question.step ?? 1}
        value={current}
        onChange={(e) => {
          // Finiteness guard for consistency with NumberInput. A range input is
          // bounded so NaN is unlikely, but never store one: fall back to the
          // current value (onAnswer's signature disallows null here).
          const n = Number(e.target.value);
          onAnswer(Number.isFinite(n) ? n : current);
        }}
        style={{ width: "100%", accentColor: "var(--color-accent)" }}
      />
      <div style={{ display: "flex", justifyContent: "space-between", color: "var(--color-muted)", fontSize: "0.875rem" }}>
        <span>{question.minLabel ?? question.min}</span>
        <span>{question.maxLabel ?? question.max}</span>
      </div>
    </div>
  );
}
